const lsKey = 'qic_renew_motor_ramadan'

function saveState (state) {
  localStorage.setItem(lsKey, JSON.stringify(state))
}

function savedState () {
  let result = {}

  try {
    result = JSON.parse(localStorage.getItem(lsKey))
  } catch {
  }

  return result
}

export default {
  state () {
    return {
      ramadanIsActive: false,
      ramadanExpanded: true,
      ramadanTicketsCount: 0,
      ramadanPlanCount: 0,
      ...savedState()
    }
  },
  mutations: {
    setRamadanIsActive (state, isActive) {
      state.ramadanIsActive = isActive
      saveState(state)
    },
    setRamadanExpanded (state, ramadanExpanded) {
      state.ramadanExpanded = ramadanExpanded
      saveState(state)
    },
    setRamadanTicketsCount (state, ramadanTicketsCount) {
      state.ramadanTicketsCount = ramadanTicketsCount
      saveState(state)
    },
    setRamadanPlanCount (state, ramadanPlanCount) {
      state.ramadanPlanCount = ramadanPlanCount
      saveState(state)
    }
  }
}
